module.exports = __webpack_public_path__ + "merge_straight.svg?58fc304a97ea343fd44a639f190fe08a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/merge_straight.svg
// module id = 181
// module chunks = 0